export default "__VITE_ASSET__DIFYCqBJ__"